import { render, staticRenderFns } from "./ArticleLabel.vue?vue&type=template&id=30c76f24&scoped=true&"
import script from "./ArticleLabel.vue?vue&type=script&lang=js&"
export * from "./ArticleLabel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLabel.vue?vue&type=style&index=0&id=30c76f24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c76f24",
  null
  
)

export default component.exports